import {asyncHttpPost, httpDelete, httpGet, httpPost, httpPut} from "../libs/http";

export const getContentWriterProjects = (page, per_page, search_query, filters, onSuccess, onFailure) => dispatch => {
    let search = [];

    for(let i = 0; i < search_query.length; i++) {
        search.push('search=' + search_query[i]);
    }

    let search_param = '';

    if(search.length > 0) {
        search_param = '&' + search.join('&')
    }

    let filter_param = '';

    if(filters !== null) {
        let filter_keys = Object.keys(filters);

        for(let i = 0; i < filter_keys.length; i++) {
            if(filters[filter_keys[i]] !== null) {
                for(let j = 0; j < filters[filter_keys[i]].length; j++) {
                    filter_param += '&' + filter_keys[i] + '=' + filters[filter_keys[i]][j];
                }
            }
        }
    }

    httpGet('/content-writer/?page=' + page + '&per_page=' + per_page + search_param + filter_param, (res) => onSuccess(res), (err) => onFailure(err));
};

export const addContentWriterProject = (data, onSuccess, onFailure) => dispatch => {
    httpPost('/content-writer/', data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const updateContentWriterSettings = (data, onSuccess, onFailure) => dispatch => {
    httpPut('/content-writer/', data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const saveContentWriterProject = (guid, data, onSuccess, onFailure) => dispatch => {
    httpPost('/content-writer/' + guid + '/', data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const loadContentWriterProject = (guid, onSuccess, onFailure) => dispatch => {
    httpGet('/content-writer/' + guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
}

export const deleteContentWriterProject = (guid, onSuccess, onFailure) => dispatch => {
    httpDelete('/content-writer/' + guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
}

export const loadContentWriterArticles = (guid, page, per_page, search_query, filters, onSuccess, onFailure) => dispatch => {
    let search = [];

    for(let i = 0; i < search_query.length; i++) {
        search.push('search=' + search_query[i]);
    }

    let search_param = '';

    if(search.length > 0) {
        search_param = '?' + search.join('&')
    }

    let filter_param = '';

    if(filters !== null) {
        let filter_keys = Object.keys(filters);

        for(let i = 0; i < filter_keys.length; i++) {
            if(filters[filter_keys[i]] !== null) {
                for(let j = 0; j < filters[filter_keys[i]].length; j++) {
                    filter_param += '&' + filter_keys[i] + '=' + filters[filter_keys[i]][j];
                }
            }
        }
    }

    httpGet('/content-writer/' + guid + '/articles/' + search_param + filter_param, (res) => onSuccess(res), (err) => onFailure(err));
}

export const loadContentWriterArticle = (project_guid, article_guid,  onSuccess, onFailure) => dispatch => {
    httpGet('/content-writer/' + project_guid + '/articles/' + article_guid + '/', (res) => onSuccess(res), (err) => onFailure(err));
}

export const updateContentWriterArticle = (project_guid, article_guid, data, onSuccess, onFailure) => dispatch => {
    httpPost('/content-writer/' + project_guid + '/articles/' + article_guid + '/',  data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const deleteContentWriterArticle = (project_guid, article_guid, data, onSuccess, onFailure) => dispatch => {
    httpDelete('/content-writer/' + project_guid + '/articles/' + article_guid + '/',  data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const generateContentWriterArticle = (project_guid, article_guid, data, onSuccess, onFailure) => dispatch => {
    httpPost('/content-writer/' + project_guid + '/articles/' + article_guid + '/generate/',  data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const createContentWriterArticle = (project_guid, data, onSuccess, onFailure) => dispatch => {
    httpPost('/content-writer/' + project_guid + '/articles/',  data, (res) => onSuccess(res), (err) => onFailure(err));
}

export const generateContentWriterPersona = (data,  onSuccess, onFailure) => dispatch => {
    httpPost('/content-writer/generate-persona/', data,  (res) => onSuccess(res), (err) => onFailure(err));
}

export const rewriteSelectedText = (project_guid, article_guid, data) => dispatch => {
    return asyncHttpPost('/content-writer/' + project_guid + '/articles/' + article_guid + '/rewrite/', data);
}

export const checkContentWriterGenerationStatus = (request_id,  onSuccess, onFailure) => dispatch => {
    httpGet('/content-writer/article-generator/' + request_id + '/', (res) => onSuccess(res), (err) => onFailure(err));
}
